import React from 'react';
import './style.scss';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: 'primary' | 'secondary';
  hidden?: boolean;
  tabIndex?: number;
}

export const ButtonCTA: React.FC<IProps> = ({
  children,
  variant,
  tabIndex = 0,
  hidden = false,
  ...props
}) => {
  return (
    <button
      type={props.type || 'button'}
      {...props}
      tabIndex={tabIndex}
      hidden={hidden}
      className={
        props.className ? `${variant}-cta ${props.className}` : `${variant}-cta`
      }
    >
      {children}
    </button>
  );
};

export default ButtonCTA;
